import { render } from "./CustomAlert.vue?vue&type=template&id=455cd3e8"
import script from "./CustomAlert.vue?vue&type=script&lang=js"
export * from "./CustomAlert.vue?vue&type=script&lang=js"
script.render = render

export default script